import i18n from './i18n';

export const MSG_ALREADY_AUTHENTICATED = () => i18n.t('auth.alreadyAuthenticated')
export const MSG_CHANGE_PASSWORD = () => i18n.t('auth.changePasswordSuccess')
export const MSG_RESET_PASSWORD = email => i18n.t('auth.resetPasswordSent', { email })
export const MSG_RESET_ADMIN_PASSWORD = () => i18n.t('auth.resetAdminPasswordSent')
export const MSG_NO_PLAYS = () => i18n.t('accountPlayers.noPlays')
